import { render, staticRenderFns } from "./SharedRecordsDocumentList.vue?vue&type=template&id=8bda222e&scoped=true"
import script from "./SharedRecordsDocumentList.vue?vue&type=script&lang=js"
export * from "./SharedRecordsDocumentList.vue?vue&type=script&lang=js"
import style0 from "./SharedRecordsDocumentList.vue?vue&type=style&index=0&id=8bda222e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bda222e",
  null
  
)

export default component.exports